<template>
  <div class="ml-2">
    <h3 class="mb-2">List Charts</h3>
    <div class="chart-list-container mt-5">
      <div v-for="chart in charts" :key="chart.uuid">

        <span class="chart-container text-left" v-on:click="loadChart(chart)">
          {{chart.name}}
        </span>

        <span v-on:click="deleteChart(chart)"> - </span>
      </div>
    </div>
  </div>
</template>

<script>
import apiCall from '@/assets/js/stockifyApi';
import { CHART_URL } from '@/assets/js/endpoints';

export default {
  name: 'ChartList',
  data() {
    return {
      charts: [],
    };
  },
  methods: {
    getCharts() {
      apiCall({
        url: CHART_URL,
      }).then((response) => {
        this.charts = response.data;
      });
    },
    loadChart(chart) {
      this.$router.push(`/chart/view/${chart.uuid}`);
    },
    deleteChart(chart) {
      apiCall({
        method: 'DELETE',
        url: `${CHART_URL}/${chart.uuid}`,
      }).then(() => {
        this.getCharts();
      });
    },
  },
  mounted() {
    this.getCharts();
  },
};
</script>

<style>
  .chart-container {
    cursor: pointer;
  }
</style>
